/* Nacrelle theme — panier, formules d'achat, galerie. Les montants viennent toujours de Shopify (cart.js, prix de variantes, selling plans). */
(() => {
  const N = window.Nacrelle || {};
  const R = N.routes || {};
  /* Les traductions Shopify arrivent échappées en HTML : on les décode une fois, puis on ré-échappe à l'affichage. */
  const decode = (s) => { const el = document.createElement('textarea'); el.innerHTML = s; return el.value; };
  const T = Object.fromEntries(Object.entries(N.t || {}).map(([k, v]) => [k, decode(v)]));
  const root = R.root || '/';
  // Notation française : « 82,99 € », espace insécable classique (U+00A0) ; Intl met une espace fine (U+202F) que nos polices n'ont pas.
  const nbsp = (s) => String(s).replace(/[\u202F\u2009 ](?=€)/g, '\u00A0').replace(/\u202F/g, '\u00A0');
  const money = (cents) => nbsp(new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const json = (r) => (r.ok ? r.json() : r.json().then((e) => Promise.reject(e)));
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  const STARTER_KEY = '_formule';

  /* ---------- Panier (latéral et page) ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const roots = () => document.querySelectorAll('[data-cart-root]');
  let lastFocus = null;
  let cartState = null;
  let healing = false;
  let busy = false;
  const SWAP = N.subSwap || null;
  let closing;
  const stillMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const flash = (m) => roots().forEach((r) => { const box = r.querySelector('[data-ship-status]'); if (box) box.insertAdjacentHTML('afterbegin', `<p class="form-error" role="alert">${esc(m)}</p>`); });
  const isStarter = (it) => it.properties && it.properties[STARTER_KEY] === 'renouvellement';
  const isStarterBrush = (it) => !it.selling_plan_allocation && isStarter(it);
  const isStarterHead = (it) => !!it.selling_plan_allocation && (isStarter(it) || (SWAP && it.variant_id === SWAP.to));

  function openDrawer() {
    if (!drawer) return;
    clearTimeout(closing);
    drawer.classList.remove('is-closing');
    if (drawer.hidden) lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('no-scroll');
    drawer.querySelector('.drawer-panel').focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden || drawer.classList.contains('is-closing')) return;
    drawer.classList.add('is-closing');
    document.documentElement.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
    closing = setTimeout(() => { drawer.hidden = true; drawer.classList.remove('is-closing'); }, stillMotion() ? 0 : 240);
  }

  const truck = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><circle cx="6.5" cy="17" r="1.8" fill="var(--c-surface)" stroke="currentColor" stroke-width="1.5"/><circle cx="17" cy="17" r="1.8" fill="var(--c-surface)" stroke="currentColor" stroke-width="1.5"/></svg>';

  /* Message + jalon de livraison offerte. La formule (starter + tête) a son propre profil de livraison gratuit,
     vérifié au paiement ; la fonction « Livraison offerte avec abonnement » rend aussi gratuits les autres envois d'un panier mixte. */
  function shippingHTML(cart) {
    if (!cart.item_count) return '';
    const hasSub = cart.items.some((it) => it.selling_plan_allocation);
    const others = cart.items.filter((it) => !it.selling_plan_allocation && !isStarter(it));
    const threshold = N.freeShippingThreshold || 7900;
    const othersTotal = others.reduce((s, i) => s + i.final_line_price, 0);
    let msg; let pct; let ok;
    if (hasSub) { msg = N.subFreeShippingVerified ? (others.length ? T.shippingMixed : T.shippingSub) : T.shippingSubPending; pct = 100; ok = true; }
    else {
      const base = hasSub ? othersTotal : cart.items_subtotal_price;
      ok = base >= threshold;
      pct = Math.min(100, Math.round((base / threshold) * 100));
      msg = ok ? T.shippingFree : (T.shippingLeft || '').replace('__AMOUNT__', money(threshold - base));
      if (hasSub && !ok) msg = `${T.shippingMixed}`;
    }
    return `<p class="ship-msg${ok ? ' ship-msg--ok' : ''}">${esc(msg)}</p>
      <div class="ship-track" role="progressbar" aria-label="${esc(T.milestone)}" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${pct}">
        <div class="ship-rail"><span style="width:${pct}%"></span></div>
        <div class="ship-stop${ok ? ' is-reached' : ''}" style="left:100%"><span class="ship-icon">${truck}</span><span class="ship-label">${esc(T.milestone)}</span></div>
      </div>`;
  }

  function subToggleHTML(it) {
    if (!SWAP || (cartState && hasFormula(cartState))) return '';
    const plain = it.variant_id === SWAP.from && !it.selling_plan_allocation;
    const subbed = it.variant_id === SWAP.to && it.selling_plan_allocation && !isStarter(it);
    if (!plain && !subbed) return '';
    const detail = (T.subToggleDetail || '').replace('__PRICE__', money(SWAP.price)).replace('__WAS__', money(SWAP.fromPrice));
    return `<button type="button" class="sub-toggle${subbed ? ' is-on' : ''}" data-sub-swap="${subbed ? 'off' : 'on'}" data-key="${esc(it.key)}" data-qty-now="${it.quantity}" aria-pressed="${subbed}">
      <span class="sub-box" aria-hidden="true"></span>
      <span><strong>${esc(subbed ? T.subOn : T.subToggle)}</strong><span class="small">${esc(subbed ? T.subOff : detail)}</span></span>
    </button>`;
  }

  /* La formule est affichée comme une seule ligne : brosse + première tête, prix du jour et prix récurrent. */
  const formulaHead = (cart) => cart.items.find((i) => i.selling_plan_allocation && isStarter(i));
  const formulaBrush = (cart) => cart.items.find(isStarterBrush);
  const hasFormula = (cart) => !!(formulaHead(cart) && formulaBrush(cart));
  const visibleCount = (cart) => cart.item_count - (hasFormula(cart) ? formulaHead(cart).quantity : 0);
  const visibleLines = (cart) => (hasFormula(cart) ? cart.items.filter((i) => i !== formulaHead(cart)) : cart.items);

  function lineHTML(it, cart) {
    const head = cart && isStarterBrush(it) ? formulaHead(cart) : null;
    const sub = it.selling_plan_allocation;
    let meta = '';
    if (head) {
      const saved = it.original_line_price - it.final_line_price - head.final_line_price;
      meta = `<p class="line-meta"><span class="badge badge--soft">${esc(T.subLabel)}</span> Brosse et première tête</p>
              <p class="line-save">Économisez ${esc(money(saved).replace(',00', ''))} + Livraison offerte</p>
              <p class="line-meta small"><strong>Puis ${money(head.selling_plan_allocation.price * it.quantity)} tous les 2 mois</strong> pour une tête neuve. La brosse n'est jamais refacturée.</p>`;
    } else if (sub) {
      meta = `<p class="line-meta"><span class="badge badge--soft">${esc(T.subLabel)}</span> ${esc(nbsp(sub.selling_plan.name))}</p>
              <p class="line-meta small muted">${esc(T.subNext)} · ${money(sub.price * it.quantity)}</p>`;
    } else if (isStarter(it)) {
      meta = `<p class="line-meta"><span class="badge badge--soft">${esc(T.starterLabel)}</span> achat unique, jamais refacturé</p>`;
    }
    /* Coffrets : tailles choisies (propriétés visibles, aussi sur la commande). */
    const props = it.properties ? Object.entries(it.properties).filter(([k, v]) => k[0] !== '_' && k !== 'Abonnement' && v) : [];
    if (!meta && props.length) meta = `<p class="line-meta small">${props.map(([k, v]) => `${esc(k)} : ${esc(v)}`).join(' · ')}</p>`;
    const img = it.image ? `<img src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'))}" alt="" width="100" height="100" loading="lazy">` : '';
    const was = !head && it.original_line_price > it.final_line_price ? `<s class="muted small">${money(it.original_line_price)}</s> ` : '';
    const linePrice = head ? it.final_line_price + head.final_line_price : it.final_line_price;
    return `<li class="line" data-key="${esc(it.key)}">
      <a class="line-media" href="${esc(it.url)}">${img}</a>
      <div class="line-info">
        <div class="line-top"><a class="line-title" href="${esc(it.url)}">${esc(it.product_title)}</a><p class="line-price">${was}${money(linePrice)}</p></div>
        ${meta}
        <div class="line-actions">
          <div class="qty-box" role="group" aria-label="${esc(T.quantity)}">
            <button type="button" data-qty="${it.quantity - 1}" data-key="${esc(it.key)}" aria-label="Diminuer">−</button>
            <span aria-live="polite">${it.quantity}</span>
            <button type="button" data-qty="${it.quantity + 1}" data-key="${esc(it.key)}" aria-label="Augmenter">+</button>
          </div>
          <button type="button" class="icon-btn line-remove" data-qty="0" data-key="${esc(it.key)}" aria-label="${esc(T.remove)}">
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12M10.5 10.5v6M13.5 10.5v6" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          </button>
        </div>
      </div>
      ${subToggleHTML(it)}
    </li>`;
  }

  /* Frais de port évités : uniquement quand la commande est réellement livrée gratuitement (abonnement ou seuil atteint). */
  const SHIP_CENTS = N.standardShippingCents || 499;
  const FREE_FROM = () => N.freeShippingThreshold || 11999;
  const hasSubIn = (cart) => cart.items.some((it) => it.selling_plan_allocation);
  const shipsFree = (cart) => hasSubIn(cart) || cart.items_subtotal_price >= FREE_FROM();

  /* Ligne d'économie d'une suggestion : toujours un montant vérifiable, sinon rien. */
  function upsellSave(u, cart) {
    if (hasSubIn(cart)) return 'Expédié avec votre abonnement, sans frais de port';
    const after = cart.items_subtotal_price + u.price;
    if (cart.items_subtotal_price < FREE_FROM() && after >= FREE_FROM()) return `Débloque la livraison offerte · −${money(SHIP_CENTS)}`;
    if (cart.items_subtotal_price >= FREE_FROM()) return 'Livraison offerte incluse';
    return '';
  }

  function upsellHTML(cart) {
    const inCart = new Set(cart.items.map((i) => i.variant_id));
    if (SWAP) cart.items.forEach((i) => { if (i.variant_id === SWAP.to) inCart.add(SWAP.from); });
    const list = (N.upsells || []).filter((u) => u.available && !inCart.has(u.id));
    if (!cart.item_count || !list.length) return '';
    return `<p class="upsell-title">${esc(T.upsellTitle)}</p>
      <ul class="upsell-list" role="list">${list.map((u) => {
        const save = upsellSave(u, cart);
        return `<li class="upsell-row">
        <a class="upsell-thumb" href="${esc(u.url)}"><img src="${esc(u.image)}" alt="" width="64" height="64" loading="lazy"></a>
        <div class="upsell-body">
          <a class="upsell-name" href="${esc(u.url)}">${esc(u.title)}</a>
          <span class="upsell-price">${money(u.price)}</span>
          ${save ? `<span class="save-text">${esc(save)}</span>` : ''}
        </div>
        <button type="button" class="upsell-add" data-quick-add="${u.id}" aria-label="${esc(T.add)} : ${esc(u.title)}">${esc(T.add)}</button></li>`;
      }).join('')}</ul>`;
  }

  /* Récapitulatif des économies, calculé sur les montants Shopify du panier. */
  function savingsHTML(cart) {
    let product = 0; let sub = 0;
    cart.items.forEach((it) => {
      if (isStarterBrush(it)) {
        const head = formulaHead(cart);
        // Formule : prix d'achat unique de la brosse comparé à ce qui est payé aujourd'hui (brosse + première tête).
        if (head) sub += it.original_line_price - it.final_line_price - head.final_line_price;
      } else if (!(isStarter(it) && it.selling_plan_allocation)) {
        const diff = Math.max(0, it.original_line_price - it.final_line_price);
        if (it.selling_plan_allocation) sub += diff; else product += diff;
      }
    });
    product += (cart.cart_level_discount_applications || []).reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
    const ship = shipsFree(cart) ? SHIP_CENTS : 0;
    const total = product + sub + ship;
    if (total <= 0) return '';
    const row = (label, v) => (v > 0 ? `<div><dt>${esc(label)}</dt><dd>−${money(v)}</dd></div>` : '');
    return `<dl class="save-box">
      ${row('Économie abonnement', sub)}${row('Économie produits', product)}${row('Livraison offerte', ship)}
      <div class="save-total"><dt>Total économisé</dt><dd>${money(total)}</dd></div></dl>`;
  }

  /* Garde-fou côté thème : une brosse de formule sans tête en abonnement est ramenée au nombre de têtes.
     Ce n'est pas un contrôle serveur (voir ISSUES.md : validation panier Shopify à prévoir). */
  async function healStarter(cart) {
    if (healing) return null;
    const brushes = cart.items.filter(isStarterBrush);
    const heads = cart.items.filter(isStarterHead).reduce((s, i) => s + i.quantity, 0);
    const brushQty = brushes.reduce((s, i) => s + i.quantity, 0);
    if (!brushes.length || brushQty <= heads) return null;
    healing = true;
    let left = heads; const updates = {};
    brushes.forEach((b) => { const q = Math.min(b.quantity, left); updates[b.key] = q; left -= q; });
    try { return await post(R.cartUpdate + '.js', { updates }); } finally { healing = false; }
  }

  async function renderCart(cart) {
    cart = cart || (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then(json));
    const healed = await healStarter(cart);
    if (healed) { cart = healed; setTimeout(() => flash(T.starterFixed), 0); }
    cartState = cart;
    const shown = visibleCount(cart);
    const inCartIds = new Set(cart.items.filter((i) => !i.selling_plan_allocation && !isStarter(i)).map((i) => i.variant_id));
    document.querySelectorAll('.addon-btn[data-quick-add]').forEach((b) => {
      const on = inCartIds.has(Number(b.dataset.quickAdd));
      b.classList.toggle('is-added', on);
      b.textContent = on ? '✓ Ajouté' : '+ Ajouter';
    });
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      const changed = el.textContent.trim() !== String(shown);
      el.textContent = shown;
      el.hidden = cart.item_count === 0;
      if (changed) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => { el.textContent = `(${shown})`; });
    const recurring = cart.items.filter((i) => i.selling_plan_allocation).reduce((s, i) => s + i.selling_plan_allocation.price * i.quantity, 0);
    roots().forEach((r) => {
      const body = r.querySelector('[data-cart-body]');
      const foot = r.querySelector('[data-cart-foot]');
      r.querySelector('[data-ship-status]').innerHTML = shippingHTML(cart);
      if (!cart.item_count) {
        body.innerHTML = `<div class="drawer-empty"><p>${esc(T.empty)}</p><a class="btn btn--primary" href="${root}collections/routine">${esc(T.discover)}</a></div>`;
        foot.hidden = true;
      } else {
        body.innerHTML = `<ul class="lines" role="list">${visibleLines(cart).map((i) => lineHTML(i, cart)).join('')}</ul>`;
        foot.hidden = false;
      }
      r.querySelector('[data-cart-upsell]').innerHTML = upsellHTML(cart);
      const saveBox = r.querySelector('[data-cart-savings]');
      if (saveBox) saveBox.innerHTML = savingsHTML(cart);
      r.querySelector('[data-subtotal-label]').textContent = `${T.today} (${shown} ${shown > 1 ? "articles" : "article"})`;
      const cmp = r.querySelector('[data-cart-compare]');
      const originalItems = cart.items.reduce((s, i) => s + i.original_line_price, 0);
      cmp.hidden = hasFormula(cart) || !(originalItems > cart.items_subtotal_price);
      cmp.textContent = cmp.hidden ? '' : money(originalItems);
      r.querySelector('[data-cart-total]').textContent = money(cart.items_subtotal_price);
      r.querySelector('[data-recurring-row]').hidden = recurring === 0;
      r.querySelector('[data-cart-recurring]').textContent = recurring ? `${money(recurring)}${N.subFreeShippingVerified ? ', livraison offerte' : ''}` : '';
      const others = cart.items.filter((it) => !it.selling_plan_allocation && !isStarter(it));
      const hasSub = recurring > 0;
      const trust = r.querySelector('.cart-trust');
      if (trust) trust.textContent = hasSub ? 'Retour sous 14 jours | Renouvellements livrés gratuitement | Sans engagement' : 'Retour sous 14 jours | Paiement sécurisé';
      const why = r.querySelector('[data-formula-why]');
      if (why) why.hidden = !hasFormula(cart);
      r.querySelector('[data-ship-note]').textContent = hasSub ? 'Livraison offerte sur toute la commande'
        : (cart.items_subtotal_price >= (N.freeShippingThreshold || 11999) ? T.shippingFree : 'Livraison ' + decode(N.standardShipping || '4,99 €') + ' sous le seuil, confirmée à l’étape suivante');
      const codes = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      const dMsg = r.querySelector('[data-discount-msg]');
      if (dMsg && codes.length) { dMsg.hidden = false; dMsg.classList.remove('form-error'); dMsg.textContent = `Code appliqué : ${codes.join(', ')}`; }
    });
    return cart;
  }

  /* Change une ligne ; les deux lignes de la formule renouvellement restent toujours liées (même quantité). */
  async function changeLine(key, qty) {
    const cart = cartState || (await renderCart());
    const item = cart.items.find((i) => i.key === key);
    if (!item) return;
    const updates = {};
    updates[key] = Math.max(0, qty);
    if (isStarter(item)) {
      cart.items.filter((i) => i.key !== key && isStarter(i)).forEach((i) => { updates[i.key] = Math.max(0, qty); });
    }
    const next = await post(R.cartUpdate + '.js', { updates });
    await renderCart(next);
  }

  /* Achat unique <-> abonnement : remplace la ligne par la variante du plan Shopify réel (ou l'inverse). */
  async function swapLine(key, qty, dir) {
    if (!SWAP) return;
    const updates = {}; updates[key] = 0;
    await post(R.cartUpdate + '.js', { updates });
    const item = dir === 'on' ? { id: SWAP.to, quantity: qty, selling_plan: SWAP.plan } : { id: SWAP.from, quantity: qty };
    await post(R.cartAdd + '.js', { items: [item] });
    await renderCart();
  }

  /* Bouton principal : le panier ne garde qu'une brosse principale. Déjà là : on ouvre le panier. Autre formule : on la remplace. */
  async function setMain(f, v) {
    const cart = await renderCart();
    const plainBrush = cart.items.filter((i) => i.variant_id === v.brush && !isStarter(i));
    const formula = cart.items.filter(isStarter);
    if (f === 'renouvellement' ? hasFormula(cart) : plainBrush.length && !formula.length) { if (!document.querySelector('[data-cart-page]')) openDrawer(); return cart; }
    const items = f === 'renouvellement'
      ? [{ id: v.brush, quantity: 1, properties: Object.assign({ _formule: 'renouvellement' }, v.note ? { Abonnement: v.note } : {}) }, { id: v.head, quantity: 1, selling_plan: v.plan, properties: { _formule: 'renouvellement' } }]
      : [{ id: v.brush, quantity: 1 }];
    /* Shopify fusionne une même variante quand la propriété commence par « _ » : on retire d'abord l'ancienne option. En cas d'échec, on la remet. */
    const old = f === 'renouvellement' ? plainBrush : formula;
    if (old.length) {
      const updates = {};
      old.forEach((i) => { updates[i.key] = 0; });
      await post(R.cartUpdate + '.js', { updates });
    }
    try {
      await post(R.cartAdd + '.js', { items });
    } catch (ex) {
      if (old.length) await post(R.cartAdd + '.js', { items: old.map((i) => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties, selling_plan: i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.id : undefined })) }).catch(() => {});
      await renderCart();
      throw ex;
    }
    await renderCart();
    if (!document.querySelector('[data-cart-page]')) openDrawer();
    return cartState;
  }

  /* Une seule action panier à la fois : un double clic ne peut rien ajouter deux fois. */
  async function locked(fn) {
    if (busy) return;
    busy = true;
    roots().forEach((r) => r.classList.add('is-busy'));
    try { await fn(); } finally { busy = false; roots().forEach((r) => r.classList.remove('is-busy')); }
  }

  async function addItems(items) {
    await post(R.cartAdd + '.js', { items });
    await renderCart();
    if (!document.querySelector('[data-cart-page]')) openDrawer();
  }

  document.addEventListener('click', async (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer && !document.querySelector('[data-cart-page]')) { e.preventDefault(); await renderCart(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const q = e.target.closest('[data-qty][data-key]');
    if (q) { await locked(async () => { q.disabled = true; try { await changeLine(q.dataset.key, Number(q.dataset.qty)); } catch (err) { await renderCart().catch(() => {}); flash((err && err.description) || T.error); } }); return; }
    const sw = e.target.closest('[data-sub-swap]');
    if (sw) { await locked(async () => { sw.disabled = true; try { await swapLine(sw.dataset.key, Number(sw.dataset.qtyNow), sw.dataset.subSwap); } catch (err) { await renderCart().catch(() => {}); flash((err && err.description) || T.error); } }); return; }
    const step = e.target.closest('[data-upsell-step]');
    if (step) { const tr = step.closest('[data-cart-root]').querySelector('[data-upsell-track]'); if (tr) tr.scrollBy({ left: Number(step.dataset.upsellStep) * tr.clientWidth * 0.8, behavior: 'smooth' }); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      if (quick.classList.contains('is-added')) { await renderCart(); openDrawer(); return; }
      await locked(async () => {
        quick.disabled = true; quick.classList.add('is-loading');
        try { await addItems([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]); } catch (err) { await renderCart().catch(() => {}); openDrawer(); flash((err && err.description) || T.error); }
        quick.disabled = false; quick.classList.remove('is-loading');
      });
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  document.addEventListener('submit', async (e) => {
    const discountForm = e.target.closest('[data-discount-form]');
    if (!discountForm) return;
    e.preventDefault();
    const code = discountForm.discount.value.trim();
    const msg = discountForm.closest('[data-cart-root]').querySelector('[data-discount-msg]');
    const cart = await post(R.cartUpdate + '.js', { discount: code });
    const ok = !code || (cart.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
    await renderCart(cart);
    msg.classList.toggle('form-error', !ok);
    msg.hidden = ok;
    msg.textContent = ok ? '' : T.discountInvalid;
  });

  /* ---------- Quantité ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input[type="number"]');
    const v = Math.min(Number(input.max || 99), Math.max(Number(input.min || 1), Number(input.value || 1) + Number(b.dataset.qtyStep)));
    input.value = v;
  });

  /* ---------- Fiches génériques (avec ou sans plan d'abonnement réel) ---------- */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const err = form.querySelector('[data-form-error]');
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(form);
      const item = { id: Number(fd.get('id')), quantity: Math.max(1, Number(fd.get('quantity') || 1)) };
      const plan = fd.get('selling_plan');
      if (plan) {
        item.selling_plan = Number(plan);
        if (form.dataset.subVariant) item.id = Number(form.dataset.subVariant);
      }
      err.hidden = true;
      try { await addItems([item]); } catch (ex) { err.textContent = (ex && ex.description) || T.error; err.hidden = false; }
    });
  });

  /* ---------- Galerie ---------- */
  document.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-gallery-track]');
    const thumbs = g.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const target = g.querySelector('#' + t.dataset.galleryThumb);
      if (target) track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
    }));
  });

  /* ---------- Navigation mobile ---------- */
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    let navTimer;
    const setNav = (open) => {
      clearTimeout(navTimer);
      navToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        nav.hidden = false;
        void nav.offsetWidth;
        nav.classList.add('is-open');
      } else {
        nav.classList.remove('is-open');
        navTimer = setTimeout(() => { nav.hidden = true; }, stillMotion() ? 0 : 220);
      }
    };
    navToggle.addEventListener('click', () => setNav(navToggle.getAttribute('aria-expanded') !== 'true'));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && navToggle.getAttribute('aria-expanded') === 'true') { setNav(false); navToggle.focus(); } });
    document.addEventListener('click', (e) => { if (navToggle.getAttribute('aria-expanded') === 'true' && !e.target.closest('[data-header]')) setNav(false); });
  }

  /* ---------- En-tête : ombre une fois détaché du haut ; sur mobile, s'efface en descendant et revient en remontant ---------- */
  const header = document.querySelector('[data-header]');
  if (header) {
    const wrap = header.parentElement;
    const desk = matchMedia('(min-width: 990px)');
    let start = null;
    let lastY = window.scrollY;
    let ticking = false;
    const onScroll = () => {
      ticking = false;
      const y = window.scrollY;
      if (start === null) { const bar = document.querySelector('[data-announcement]'); start = bar ? bar.offsetHeight : 0; } // wrap.offsetTop change dès que l'en-tête colle
      header.classList.toggle('is-stuck', y > start);
      const navOpen = navToggle && navToggle.getAttribute('aria-expanded') === 'true';
      if (desk.matches || navOpen || y < 320 || header.contains(document.activeElement)) wrap.classList.remove('header-away');
      else if (y > lastY + 6) wrap.classList.add('header-away');
      else if (y < lastY - 6) wrap.classList.remove('header-away');
      if (Math.abs(y - lastY) > 6) lastY = y;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    header.addEventListener('focusin', () => wrap.classList.remove('header-away'));
    if (lastY > 0) requestAnimationFrame(onScroll);
  }

  /* ---------- Apparition douce : une seule fois, à partir d'un état déjà visible, jamais pour ce qui est à l'écran au chargement ---------- */
  // iOS Safari active :active seulement avec un écouteur tactile.
  document.addEventListener('touchstart', () => {}, { passive: true });

  const REVEAL = '.reveal, .addon, .pdp-acc details, .section-head, .stories-head, .stories-photos, .stories-grid, .stories-more, .usp-head, .usp-media, .usp, .cmp-head, .cmp-wrap, .reviews-head, .rv-summary, .rv-tools, .review-grid, .carousel-head, .carousel-track, .faq-split-intro, .faq-split-list, .footer-top';
  if ('IntersectionObserver' in window && !stillMotion()) {
    // Deux observateurs, aucune mesure forcée : un bloc n'est armé qu'à l'approche de l'écran (rien à payer pour ce qu'on ne voit pas),
    // puis révélé une seule fois. Ce qui est déjà à l'écran ou plus haut n'est jamais touché.
    const show = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting || en.boundingClientRect.top < 0) { en.target.classList.remove('is-pending'); show.unobserve(en.target); }
    }), { rootMargin: matchMedia('(max-width: 989px)').matches ? '0px 0px -16% 0px' : '0px 0px -8% 0px' }); // sur mobile : au-dessus de la barre d'achat collante, sinon l'effet se joue dessous
    const near = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      near.unobserve(en.target);
      if (en.boundingClientRect.top >= window.innerHeight) { en.target.classList.add('m-reveal', 'is-pending'); show.observe(en.target); }
    }), { rootMargin: '0px 0px 45% 0px' });
    document.querySelectorAll(REVEAL).forEach((el) => { if (!el.parentElement.closest(REVEAL)) near.observe(el); });
    // Défilement arrêté : rien ne reste atténué à l'écran.
    let idleTimer;
    window.addEventListener('scroll', () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => document.querySelectorAll('.is-pending').forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.remove('is-pending'); show.unobserve(el); } }), 450);
    }, { passive: true });
  }

  /* ---------- Rangées balayables : petite barre de progression (mobile) ---------- */
  document.querySelectorAll('[data-swipe-bar]').forEach((bar) => {
    const row = bar.previousElementSibling;
    const fill = bar.firstElementChild;
    let queued = false;
    const paint = () => {
      queued = false;
      const seen = (row.scrollLeft + row.clientWidth) / Math.max(1, row.scrollWidth);
      fill.style.transform = `scaleX(${Math.min(1, seen).toFixed(3)})`;
      bar.hidden = row.scrollWidth <= row.clientWidth + 1;
    };
    const ask = () => { if (!queued) { queued = true; requestAnimationFrame(paint); } };
    row.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    new MutationObserver(ask).observe(row, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
    if ('IntersectionObserver' in window) new IntersectionObserver((en, o) => { if (en[0].isIntersecting) { o.disconnect(); ask(); } }, { rootMargin: '200px' }).observe(row); else ask();
  });

  const ready = () => requestAnimationFrame(() => document.documentElement.classList.add('m-ready'));
  if (document.readyState === 'complete') ready(); else window.addEventListener('load', ready);

  /* ---------- Date indicative du prochain envoi d'abonnement ---------- */
  document.querySelectorAll('[data-next-date]').forEach((el) => {
    const d = new Date(); d.setMonth(d.getMonth() + Number(el.dataset.months || 2));
    el.textContent = 'vers le ' + new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }).format(d);
  });

  window.addEventListener('pageshow', (e) => { if (e.persisted) renderCart().catch(() => {}); });
  window.NacrelleCart = { add: addItems, setMain, render: renderCart, open: openDrawer };
  renderCart().catch(() => {});
})();
